import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
} from '@angular/core';

/**
 * Componente de contador que permite incrementar y decrementar un valor.
 * Dispara eventos cuando el valor cambia o cuando se alcanza un límite.
 */
@Component({
  selector: 'am-counter',
  templateUrl: './am-counter.component.html',
  styleUrls: ['./am-counter.component.scss'],
  standalone: false,
})
export class AmCounterComponent implements OnInit, OnChanges {
  /**
   * Valor actual del contador.
   * Se inicializa en 0 por defecto.
   */
  @Input() count = 0;

  /**
   * Habilita la capacidad de incrementar el contador.
   */
  @Input() enablePlus = false;

  /**
   * Parámetro para llevar el conteo de maletas carry-on
   */
  @Input() maxCount = Infinity;

  /**
   * CI-19510: Habilita la capacidad de decrementar el contador.
   * Por defecto es true para mantener compatibilidad con código existente.
   */
  @Input() enableMinus: boolean = true;

  /**
   * Evento que emite cuando el contador cambia de valor.
   */
  @Output() handleCount: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Evento que se emite cuando se disminuye el contador.
   */
  @Output() minus: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Evento que se dispara cuando se intenta incrementar el contador pero está deshabilitado.
   */
  @Output() onPlusLimit: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Evento que se emite cuando se incrementa el contador.
   */
  @Output() plus: EventEmitter<any> = new EventEmitter<any>();

  @Input() newdata = false;

  /** Cuando true, el onPlus no incrementa el contador sino que delega al padre */
  @Input() blockPlus = false;
  @Output() onBlockedPlus: EventEmitter<any> = new EventEmitter<any>();
  /** Cuando cambia, sincroniza count con el valor real del padre */
  private _syncCount = 0;
  @Input() set syncTrigger(value: number) {
    if (value !== this._syncCount) {
      this._syncCount = value;
      if (this._inputCount !== undefined) {
        this.count = this._inputCount;
      }
    }
  }
  private _inputCount: number;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['count']) {
      const newValue = changes['count'].currentValue;
      this._inputCount = newValue;
      if (newValue !== this.count) {
        this.count = newValue;
      }
    }
  }

  /**
   * Método para incrementar el contador.
   * Si blockPlus, delega al padre sin incrementar.
   * Si enablePlus, incrementa y emite.
   * Si no, emite onPlusLimit.
   */
  onPlus() {
    if (this.blockPlus) {
      this.onBlockedPlus.emit(this.count + 1);
      return;
    }
    if (this.enablePlus && this.count < this.maxCount) {
      this.count++;
      this.plus.emit(this.count);
      this.handleCount.emit(this.count);
    } else {
      this.onPlusLimit.emit(true);
    }
  }
  /**
   * Método para decrementar el contador.
   * CI-19510: Solo permite decrementar si enableMinus es true y el contador es mayor que 0.
   */
  onMinus() {
    if (this.enableMinus && this.count > 0) {
      this.count--;
      this.minus.emit(this.count);
      this.handleCount.emit(this.count);
    }
  }
}
